import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../../Tenants";
import { AddUserBtn } from "@/App/Units/Users/Add";
import { ComponentTableUsers } from "@/App/Units/Users/Table";
import { getUsersTenantData, searchUserTenantData } from "@/Api/unities";
import { useAuth } from "@/hooks/auth";
import { NotFound } from "@/pages/NotFound";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link, useParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import { TypeUser } from "@/types/userType";

export type TypeUsersProp = {
  id: number;
  unity_id: number;
  user_id: number;
  created_at: string;
  updated_at: string;
  user: {
    uuid: string;
    id: number;
    name: string;
    email: string;
    photo: string | null;
    tenant_id: number;
    is_active: number;
    user_type_id: number;
  };
  unity: {
    id: number;
    name: string;
    is_active: number;
  };
};

export const PageList = () => {
  const { uuid_unit } = useParams();
  const auth = useAuth();
  const [usersData, setUsersData] = useState({} as ApiDataProps<TypeUsersProp>);
  const [state, setState] = useState("loading");

  const hasAccess =
    auth?.user?.user_type_id === TypeUser.client ||
    auth?.user?.user_type_id === TypeUser.unity_responsible;

  useEffect(() => {
    if (!hasAccess || !uuid_unit) return;

    (async () => {
      const { data } = await getUsersTenantData(uuid_unit);
      setUsersData(data?.response);
      setState("production");
    })();
  }, [hasAccess, uuid_unit]);

  if (!hasAccess) return <NotFound />;

  return (
    <Main>
      <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <Link
                to={"/unidades"}
                className={cn("transition-colors hover:text-foreground")}
              >
                Unidades
              </Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>
                {usersData && usersData?.[0]?.unity?.name}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <AddUserBtn updateFront={setUsersData} uuidUnit={uuid_unit} />
      </div>
      <div className="flex flex-col gap-3">
        <SearchComponent
          updateFront={setUsersData}
          setState={setState}
          funcSearch={({ name }) => {
            if (!uuid_unit) return Promise.reject();
            return searchUserTenantData(uuid_unit, { name });
          }}
          placeholder="Pesquisar usuário"
        />
        {state === "loading" ? (
          <CreateLoaderTable cols={4} lines={6} />
        ) : (
          <ComponentTableUsers
            dataApi={usersData}
            updateFront={setUsersData}
            uuidUnit={uuid_unit}
          />
        )}
      </div>
    </Main>
  );
};
